import Model from '../orm/Model'
import Input from '../orm/Input'

import Attendance from './Attendance'
import Location from './Location'
import Team from './Team'
import Student from './Student'
import StudentEvent from './StudentEvent'

import { isEmpty } from '@/utilities'

const eventInput = new Input('EventInput!', [
    'title',
    'description',
    'date',
    'ern',
    'start_time',
    'end_time',
    'capacity',
    'visibility',
    'location_id',
    'late_time',
    'absent_time',
    'alerts_students',
    'min_percentage',
    'required',
    'restricted_by',
    'drop_cutoff'
])

export default class Event extends Model {

    static entity = 'event'

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            ern: this.attr(null),
            school_id: this.attr(0),
            location_id: this.attr(null),
            location: this.belongsTo(Location, 'location_id'),
            title: this.attr(''),
            description: this.attr(''),
            date: this.attr(''),
            start_time: this.attr(''),
            end_time: this.attr(''),
            capacity: this.attr(null),
            visibility: this.attr(false),
            public_url: this.attr(null),
            late_time: this.attr(null),
            absent_time: this.attr(null),
            min_percentage: this.attr(null),
            drop_cutoff: this.attr(240),
            alerts_students: this.attr(false),
            deleted_at: this.attr(null),
            attending_count: this.attr(null),
            waitlist_count: this.attr(null),
            in_waitlist: this.optional(null),
            is_in_session: this.attr(null),
            scan_code: this.attr(null),
            restricted_by: this.attr(null),
            restriction: this.belongsTo(Team, 'restricted_by'),

            attendance_graph: this.array([], ['label', 'value']),

            missed_event: this.array([], ['id', 'uuid', 'semester_apa', 'first_name', 'last_name']),

            students: this.belongsToMany(
                Student,
                StudentEvent,
                'event_id',
                'student_id'
            ),

            attendance: this.morphOne(Attendance,
                'attendable_id',
                'attendable_type')
        }
    }

    static graphql = {
        all: {
            type: 'events',
            paginated: true,
            parameters: {
                page: 'Int',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
                state: 'String'
            },
            include: [
                { location: true }
            ],
            exclude: [
                'scan_code',
                'is_in_session',
                'waitlist_count',
                'in_waitlist'
            ]
        },
        search: {
            type: 'events',
            paginated: true,
            parameters: {
                query: 'String',
                per_page: 'Int!',
                scoped: 'Boolean',
                state: 'String'
            },
            exclude: [
                'waitlist_count',
                'in_waitlist'
            ]
        },
        one: {
            type: 'event',
            parameters: {
                uuid: 'String!'
            },
            include: [
                'location',
                'restriction',
                'attendance_graph',
                'missed_event'
            ],
            exclude: ['in_waitlist']
        },
        create: {
            type: 'createEvent',
            parameters: {
                input: eventInput
            },
            include: {
                location: true,
            },
            exclude: ['in_waitlist']
        },
        update: {
            type: 'updateEvent',
            parameters: {
                uuid: 'String!',
                input: eventInput
            },
            include: {
                location: true,
            },
            exclude: ['in_waitlist']
        },
        remove: {
            type: 'removeEvent',
            parameters: {
                id: 'Int!'
            }
        },
        upgradeStudent: {
            type: 'upgradeStudent',
            parameters: {
                event_id: 'Int',
                student_id: 'Int'
            },
            exclude: ['in_waitlist']
        },
        scanCode: {
            type: 'event',
            parameters: {
                uuid: 'String!'
            },
            exclude: ['in_waitlist']
        },
        addTeam: {
            type: 'addTeamToEvent',
            parameters: {
                event_id: 'Int!',
                team_id: 'Int!'
            },
            exclude: ['in_waitlist']
        }
    }

    static async $search(params) {
        if (isEmpty(params.query)) return
        if (isEmpty(params.per_page)) {
            params.per_page = 5
        }
        const { data } = await this.$fetch({
            graphql: 'search',
            variables: params
        })

        return data
    }
}
